import React from 'react';
import MobileHeader from './MobileHeader';
import MobileBottomNav from './MobileBottomNav';
import Footer from './Footer';
import { useTheme } from './ParticleBackground';
import ParticleBackground from './ParticleBackground';

const MobileLayout = ({ children }) => {
    const { getThemeStyles } = useTheme();
    const themeStyles = getThemeStyles();

    return (
        <div style={{
            minHeight: '100vh',
            background: themeStyles.background,
            color: themeStyles.textColor,
            transition: 'all 0.3s ease',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <ParticleBackground
                quantity={20}
                ease={50}
                size={0.8}
                staticity={60}
                particleColor={themeStyles.particleColor}
            >
                <MobileHeader />

                <div style={{
                    flex: 1,
                    paddingTop: '60px', // Space for header
                    paddingBottom: '80px', // Space for bottom nav + extra
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch'
                }}>
                    {children}
                    <Footer />
                </div>

                <MobileBottomNav />
            </ParticleBackground>
        </div>
    );
};

export default MobileLayout;
